import { createContext, ReactNode, useState } from 'react'
import { getToken } from '../api/auth/auth'
import { AddressProps, UserProps } from '../types/user'
import jwt from 'jsonwebtoken'
import clientes from '../api/clientes'
import { useToast } from '../hooks/toast'
import { GetOrdersRequest } from '../types/pedidos'

const stringToken = getToken()
const userToken = jwt.decode(stringToken)

type UserContextProps = {
  children: ReactNode
}

export interface UpdateUserParams {
  id: string
  apelido: string
  nome: string
  dataNascimento: string
  sexo: string
  rg: string
  telefoneResidencialDDD: string
  telefoneResidencialNumero: string
  telefoneCelularDDD: string
  telefoneCelularNumero: string
  telefoneComercialDDD: string
  telefoneComercialNumero: string
  telefoneComercialRamal: string
}

type UserContextType = {
  user: UserProps
  setUser: (newState: UserProps) => void
  getUserData: () => void
  updateUser: (body: UpdateUserParams) => void
  getUserAddress: (addressList: AddressProps[]) => void
  address: Array<AddressProps>
  setAddress: (newAddress: AddressProps[]) => void
  updateAddress: (body: AddressProps) => Promise<any>
  loading: boolean
  setLoading: (state: boolean) => void
  filterParams: GetOrdersRequest; // Novo campo
  setFilterParams: (
    previousState: (
      value: GetOrdersRequest
    ) => GetOrdersRequest
  ) => void; 
}

const initialValue = {
  user: {
    ...userToken
  },
  addressList: [
    {
      id: 0,
      padrao: true,
      tipoEndereco: 'C',
      apelido: '',
      tipoLogradouro: '',
      logradouro: '',
      pontoReferencia: '',
      numero: '',
      complemento: '',
      bairro: '',
      cidade: '',
      uf: '',
      cep: ''
    }
  ],
  loading: false
}

export const UserContext = createContext<UserContextType>({} as UserContextType)

export const UserContextProvider = ({ children }: UserContextProps) => {
  const [user, setUser] = useState<UserProps>(initialValue.user)
  const [address, setAddress] = useState<AddressProps[]>(
    initialValue.addressList
  )
  const [loading, setLoading] = useState(initialValue.loading)

  const [filterParams, setFilterParams] = useState<GetOrdersRequest>({
    IdStatus: '',
    IdPedido: '',
    DataInicial: '',
    DataFinal: '',
    Page: 1,
    PageSize: 10,
  });

  const { addToast }: any = useToast()

  const getUserData = async () => {
    setLoading(true)
    if (user.cpf.trim() !== '') {
      await clientes
        .getLoggedUserPF()
        .then((res) => {
          setUser({ ...user, ...res.data[0] })
        })
        .catch((error) => console.log(error))
    } else {
      await clientes
        .getLoggedUserPJ()
        .then((res) => {
          setUser({ ...user, ...res.data[0] })
        })
        .catch((error) => console.log(error))
    }
    setLoading(false)

    // console.log(response.data[0])
  }

  const updateUser = async (body: UpdateUserParams) => {
    const response = await clientes.updateUserPF(body)

    // setUser({ ...user, ...response.data[0] })
    // console.log(response.data[0])
  }

  const getUserAddress = async () => {
    const response = await clientes.getAddress()
    setAddress(response.data)
  }

  const updateAddress = async (body: AddressProps) => {
    //     addToast({
    //       type: 'error',
    //       title:
    //         'ATENÇÃO: Não é possível cadastrar endereço de entrega com Estado diferente do endereço de faturamento'
    //     })
    // return await clientes.editAddress(body)
    console.log('Teste Update Address')
  }

  return (
    <UserContext.Provider
      value={{
        user,
        setUser,
        updateUser,
        address,
        setAddress,
        getUserData,
        getUserAddress,
        updateAddress,
        loading,
        setLoading,
        filterParams,
        setFilterParams,
      }}
    >
      {children}
    </UserContext.Provider>
  )
}
